import React from 'react';
import PropTypes from 'prop-types';
import OutsourceTreeDetail from '../../works/components/OutsourceTreeDetail';
import RouterUtils from '../../shared/routing/RouterUtils';
import { PsRoutes } from '../../shared/routing/Routes';
import WorkRequest from '../../works/ws/WorkRequest';
import { I18nUtils } from '../../../i18n/I18nUtils';

export default class WorksAccordionItem extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            contracts: [],
            contractsLoading: false,
            contractsFetched: false,
        };
    }

    render() {
        const { allowNavigateToWork, work, index } = this.props;
        const { contracts, contractsLoading, contractsFetched } = this.state;

        return (
            <div className="panel panel-col-grey">
                <div className="panel-heading" role="tab" id="heading-01">
                    <h4 className="panel-title">
                        {
                            allowNavigateToWork ? (
                                <a
                                    href={RouterUtils.generateRoute(PsRoutes.MY_OUTSOURCES_WORKS_DETAIL, { id: work.id })}
                                    title="Ver obra"
                                    className="pull-right see-works"
                                >
                                    <i className="material-icons">keyboard_arrow_right</i>
                                </a>
                            ) : null
                        }
                        <a
                            role="button"
                            data-toggle="collapse"
                            data-parent={'#accordion-' + index}
                            href={'#collapse-' + index}
                            aria-expanded="true"
                            aria-controls={'#collapse-' + index}
                            onClick={this.fetchCompanyWorkContracts}
                        >
                            {work.code} - {work.name}
                        </a>
                    </h4>
                </div>
                <div
                    id={'collapse-' + index}
                    className="panel-collapse collapse"
                    role="tabpanel"
                    aria-labelledby="heading-01"
                >
                    <div className="panel-body">
                        {
                            contractsFetched ? (
                                <OutsourceTreeDetail contracts={contracts}/>
                            ) : null
                        }
                        {
                            contractsLoading ? (
                                <div>{I18nUtils.tr('TR_CARGANDO')}</div>
                            ) : null
                        }
                    </div>
                </div>
            </div>
        );
    }

    fetchCompanyWorkContracts = () => {
        const { work } = this.props;
        const { contractsFetched } = this.state;

        const pre = () => this.setState({ contractsLoading: true });
        const success = (res) => this.setState({ contracts: res.data.contracts || [] });
        const post = () => this.setState({ contractsLoading: false, contractsFetched: true });

        if ( !contractsFetched ) {
            new WorkRequest(work.id)
                .onPreExecution(pre)
                .onSuccess(success)
                .onPostExecution(post)
                .execute();
        }
    };

}

WorksAccordionItem.propTypes = {
    work: PropTypes.any,
    index: PropTypes.number,
    allowNavigateToWork: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/app/outsource/components/WorksAccordionItem.js